import { createFileRoute } from "@tanstack/react-router"
import { AdminEvalsRoute } from "./-EvalsPage"
import { SearchSchema } from "./-evalsSearchSchema"

export const Route = createFileRoute("/admin/evals")({
  validateSearch: (search) => SearchSchema.parse(search),
  component: AdminEvalsRoute,
})
